export const RPM_STATUS = {
  pending: false,
  device: null,
};
